module.exports = __webpack_public_path__ + "media/images/next_page_icon-176709ae559acad7d49dcba545e306dd.svg";